import './EconomySavedShippingPill.scss';

import { ECONOMY_SHIPPING_SAVINGS_LABEL } from '@/constants/ShipTypes';
import { formatPrice } from '@/utilities/CommonUtils';

interface IEconomySavedShippingPillProps {
  /** Negative shipping amount; the absolute value is shown after the SAVE label */
  shipping: number | string;
  className?: string;
}

/** Two-line summary value for negative economy shipping (amount + "Savings"). */
const EconomySavedShippingPill: React.FC<IEconomySavedShippingPillProps> = ({
  shipping,
  className,
}) => {
  const priceNum = Number(shipping);

  if (!Number.isFinite(priceNum) || priceNum >= 0) {
    return null;
  }

  return (
    <span className={`economy-saved-pill ${className ?? ''}`.trim()}>
      <span className="economy-saved-pill__amount">-{formatPrice(Math.abs(priceNum))}</span>
      <span className="economy-saved-pill__label">{ECONOMY_SHIPPING_SAVINGS_LABEL}</span>
    </span>
  );
};

export default EconomySavedShippingPill;
